<template>
    <el-dialog
        :title="dialogTitle + ' 发送短信人员列表'"
        :model-value="modelValue"
        width="650px"
        @close="closed"
        align-center
        modal-class="sendMsgList"
        :close-on-click-modal="false"
    >
        <div class="handle">
            <el-button type="primary" :icon="User" @click="addSendMsgManList" v-permission="['alarm:manger:addSendMsgMan']">
                编辑短信发送人员
            </el-button>
        </div>
        <el-table :data="table_data" border style="width: 100%" height="55vh">
            <el-table-column label="序号" width="80" type="index" />
            <el-table-column label="用户名" prop="username" show-overflow-tooltip />
            <el-table-column label="性别" prop="gender" width="80">
                <template #default="{ row }">
                    <div>
                        {{ row.gender ? '男' : '女' }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="手机号" prop="phone" width="180" />
            <el-table-column label="操作" width="90">
                <template #default="{ row }">
                    <el-button type="primary" link :icon="Delete" size="small" @click="delSendMsgMan(row)">移除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <checkMsgManList
            v-if="sendMsgDialogVisible"
            v-model="sendMsgDialogVisible"
            :levelItem="currentLevelData"
            @updateManList="getAlarmLevelSettingDetailFnc"
        ></checkMsgManList>
    </el-dialog>
</template>
<script setup>
import { defineEmits, defineProps, onMounted, ref } from 'vue'
import { Delete, User } from '@element-plus/icons' // Delete
import { checkRemoveMsgMan, getAlarmLevelSettingDetail } from '@/api/eventConfig/alarmLevel/alarmLevel.js'
import checkMsgManList from './checkMsgManList.vue'
import { ElMessage } from 'element-plus'

const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true
    },
    alarmItem: {
        required: false
    }
})
const emits = defineEmits(['update:modelValue', 'updateForm'])

const dialogTitle = ref('')

const table_data = ref([])
// 关闭
const closed = () => {
    dialogTitle.value = ''
    document.querySelector('.el-dialog__body').scrollTo(0, 0)
    emits('update:modelValue', false)
}
const currentLevelData = ref({})

// 获取详情
const getAlarmLevelSettingDetailFnc = async () => {
    const res = await getAlarmLevelSettingDetail(props.alarmItem.id)
    currentLevelData.value = res
    dialogTitle.value = res.label
    table_data.value = res.message_user_lists
}

// 删除某个人
const delSendMsgMan = async (row) => {
    try {
        await checkRemoveMsgMan(props.alarmItem.id, { method: 'remove_message_lists', data: [row.userid] })
        ElMessage.success('移除成功')
        getAlarmLevelSettingDetailFnc()
    } catch (error) {}
}

// 勾选发送短信人员列表
const sendMsgDialogVisible = ref(false)
const addSendMsgManList = async () => {
    sendMsgDialogVisible.value = true
}

onMounted(async () => {
    getAlarmLevelSettingDetailFnc()
})
</script>
<style>
.sendMsgList .el-dialog__body {
    padding: 0 10px 10px 10px;
}
</style>
<style lang="scss" scoped>
.handle {
    margin-bottom: 20px;
}
</style>
